<template>
  <div class="companion-picker">
    <label class="field-label">Спутники</label>
    <div class="companion-search">
      <input
        v-model="query"
        type="text"
        class="input"
        placeholder="Поиск по @username"
        autocomplete="off"
        @input="onSearch"
      />
      <ul v-if="suggestions.length" class="companion-suggestions">
        <li v-for="user in suggestions" :key="user.id">
          <button type="button" class="companion-suggestion" @click="addCompanion(user)">
            {{ userDisplayName(user) }}
          </button>
        </li>
      </ul>
    </div>
    <div v-if="selected.length" class="companion-chips">
      <span v-for="user in selected" :key="user.id" class="companion-chip">
        <UserIdentity :user="user" size="sm">{{ userDisplayName(user) }}</UserIdentity>
        <button type="button" class="companion-remove" aria-label="Удалить" @click="removeCompanion(user.id)">
          ×
        </button>
      </span>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import UserIdentity from './UserIdentity.vue'
import { searchUsers } from '../api/trips'
import { userDisplayName } from '../utils/userDisplay'

const props = defineProps({
  modelValue: {
    type: Array,
    default: () => [],
  },
})

const emit = defineEmits(['update:modelValue'])

const query = ref('')
const suggestions = ref([])
const selected = ref([...props.modelValue])
let searchTimeout = null

watch(
  () => props.modelValue,
  (value) => {
    selected.value = [...value]
  },
  { deep: true }
)

function onSearch() {
  clearTimeout(searchTimeout)
  const value = query.value.trim()
  if (value.length < 2) {
    suggestions.value = []
    return
  }

  searchTimeout = setTimeout(async () => {
    try {
      const { data } = await searchUsers(value.replace(/^@/, ''))
      const selectedIds = new Set(selected.value.map((user) => user.id))
      suggestions.value = data.filter((user) => !selectedIds.has(user.id))
    } catch {
      suggestions.value = []
    }
  }, 250)
}

function addCompanion(user) {
  if (selected.value.some((item) => item.id === user.id)) return
  selected.value = [...selected.value, user]
  emit('update:modelValue', selected.value)
  query.value = ''
  suggestions.value = []
}

function removeCompanion(userId) {
  selected.value = selected.value.filter((user) => user.id !== userId)
  emit('update:modelValue', selected.value)
}
</script>

<style scoped>
.companion-picker {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.field-label {
  font-weight: 600;
}

.companion-search {
  position: relative;
}

.companion-suggestions {
  position: absolute;
  z-index: 10;
  top: 100%;
  left: 0;
  right: 0;
  list-style: none;
  margin: 0.25rem 0 0;
  padding: 0;
  background: #fff;
  border: 1px solid #cbd5e1;
  border-radius: 0.375rem;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);
}

.companion-suggestion {
  display: block;
  width: 100%;
  text-align: left;
  padding: 0.5rem 0.75rem;
  border: none;
  background: transparent;
  cursor: pointer;
}

.companion-suggestion:hover {
  background: #f1f5f9;
}

.companion-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.companion-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.25rem 0.5rem;
  background: #f1f5f9;
  border-radius: 999px;
}

.companion-remove {
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 1.125rem;
  line-height: 1;
  color: #64748b;
}
</style>
